import soinsData from '@/app/data/soins.json';

export interface SoinOption {
  label: string;
  duration: string;
  price: string;
}

export interface SoinFaqItem {
  question: string;
  answer: string;
}

export interface SoinStep {
  title: string;
  description?: string;
}

export interface Soin {
  slug: string;
  name: string;
  /** Description courte : cartes de l'accueil, hero de la page, référencement */
  description: string;
  /** Description longue de la page dédiée (paragraphes séparés par une ligne vide) */
  longDescription?: string;
  duration: string;
  price: string;
  /** Fichier dans /public, ex. "massage-drainant.jpg" ou "soins/drainant.png" */
  image?: string;
  options?: SoinOption[];
  /** Cartes « Pour qui » : slugs ou titres de app/data/audiences.json */
  audiences?: string[];
  /** Questions fréquentes propres au soin */
  faq?: SoinFaqItem[];
  /** Étapes du soin, affichées numérotées sur la page dédiée */
  steps?: SoinStep[];
  /** Titre de la section déroulé (par défaut : « Déroulé du soin <nom> ») */
  stepsTitle?: string;
}

export interface SoinCategory {
  slug: string;
  name: string;
  description?: string;
  soins: Soin[];
}

export interface SoinWithCategory extends Soin {
  categorySlug: string;
  categoryName: string;
}

export const soinCategories: SoinCategory[] = soinsData.categories;

export function getAllSoins(): SoinWithCategory[] {
  return soinCategories.flatMap((category) =>
    category.soins.map((soin) => ({
      ...soin,
      categorySlug: category.slug,
      categoryName: category.name,
    }))
  );
}

export function getSoinBySlug(slug: string): SoinWithCategory | undefined {
  return getAllSoins().find((soin) => soin.slug === slug);
}
